export default {
  // دراپ‌داون‌های سامانه مودیان در ماژول dropdownX نگه داشته می‌شوند
  invoices: [],
  invoicesTotalCount: 0,
  keys: [],
};
